import {Box, Link, Typography} from "@mui/material"
import {BackArrowIcon} from "../../../assets"
import {FC} from "react"
import useSelectedThoughtPiecesStore from "../../../stores/fullPageThoughtPiecesStore"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import {TruncatedTooltip} from "../../atoms/Tooltip"

type Props = {
  page?: string
  style?: React.CSSProperties
  backToRoot?: boolean
  onClick?: () => void
}
const BackButton: FC<Props> = (props) => {
  const imageStyle: React.CSSProperties = {
    ...props.style,
  }
  const {setId} = useSelectedThoughtPiecesStore()

  const handleBackClick = () => {
    props?.onClick && props.onClick()
    setId("")
  }

  return (
    <Typography>
      <Link
        component={"button"}
        underline="none"
        onClick={handleBackClick}
        id="thoughtPiecesFullPageBackButton"
        color={"#053747"}
        display={"inline-flex"}
        alignItems={"center"}
        style={{...imageStyle}}
        sx={{
          cursor: "pointer",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 600,
          fontStretch: "normal",
          fontStyle: "normal",
        }}
      >
        <BackArrowIcon fill="#053747" height={"20px"} width={"20px"} />
        <Box component={"div"} display={"flex"} textAlign={"left"}>
          {props.page ? "Back to" : "Back"}&nbsp;
        </Box>
        <Box
          component={"div"}
          display={"flex"}
          width={"400px"}
          maxWidth={"400px"}
          textAlign={"left"}
        >
          <EllipsisTypography
            text={props?.page || ""}
            lines={1}
            fontSize={14}
            tooltipComponent={TruncatedTooltip}
          />
        </Box>
      </Link>
    </Typography>
  )
}

export default BackButton
